import { $, each } from '../util'

const GlobalSearch = (() => {
  const openPanel = () => {
    const openers = $('.js-global-search-open')

    each(openers, (i, op) => {
      op.addEventListener('click', () => {
        document.body.classList.add('is-search-open')
      })
    })
  }

  const closePanel = () => {
    const closers = $('.js-global-search-close')

    each(closers, (i, cl) => {
      cl.addEventListener('click', () => {
        document.body.classList.remove('is-search-open')
      })
    })
  }

  const init = () => {
    openPanel()
    closePanel()
  }

  return {
    init,
  }
})()

export default GlobalSearch



// WEBPACK FOOTER //
// app/javascript/scripts/components/GlobalSearch.js